import { useLocation, useParams } from "react-router-dom";
import defaultS from "../../assets/images/simulations/default.webp";
import iit from "../../assets/images/simulations/iit.webp";
import cat from "../../assets/images/simulations/cat.webp";
import railway from "../../assets/images/simulations/railway.webp";

const SimulationPage = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const id = Number(params.get("id"));

  const examList = [
    {
      id: 1,
      name: "Default",
      image: defaultS,
    },
    {
      id: 2,
      name: "IIT",
      image: iit,
    },
    {
      id: 3,
      name: "CAT",
      image: cat,
    },
    {
      id: 4,
      name: "SSC/ Railways/ Gate ",
      image: railway,
    },
  ];

  const currentExam = examList.find((exam) => exam.id === id);

  return (
    <div className="relative  md:h-screen w-screen pb-5 flex justify-center items-center">
      {currentExam?.image && (
        <img
          src={currentExam.image}
          alt={currentExam.name}
          loading="lazy"
          decoding="async"
          className="h-full w-full object-contain"
        />
      )}
    </div>
  );
};

export default SimulationPage;
